import { useContext } from 'react';
import { createGQLDataContext } from 'utils/createDataContext';
import type { UseGQLQuery } from 'hooks/useGQLQuery/useGQLQuery.types';
import type { ShiftModalOrderDetailsQuery } from 'types/graphql';
import type { ShiftModalDetailsData } from 'modals/ShiftModal/ShiftModal.constants';

export const ShiftModalDataContext = createGQLDataContext({});

export const useShiftModalDataContext = (): UseGQLQuery<
  ShiftModalOrderDetailsQuery,
  ShiftModalDetailsData
> => useContext(ShiftModalDataContext);
